import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { AddYurticiCargoRequest } from "../../../models/request/yurticiCargo/AddYurticiCargoRequest";
import { YurticiCargoService } from "../../../services/YurticiCargoService";
import { AddYurticiCargoResponse } from "../../../models/response/yurticiCargo/AddYurticiCargoResponse";
import { GetYurticiCargoByIdResponse, GetYurticiCargoByIdResponseFileArchive, GetYurticiCargoByIdResponseYurticiCargoExpectedIncomeOutcome, GetYurticiCargoByIdResponseYurticiCargoMovement, GetYurticiCargoByIdResponseYurticiCargoProduct } from "../../../models/response/yurticiCargo/GetYurticiCargoByIdResponse";
import PageHeader from "../../../components/PageHeader";
import GeneralInformation from "./Components/GeneralInformation";
import { CountryService } from "../../../services/CountryService";
import { GetCountryListResponse, GetCountryListResponseData } from "../../../models/response/country/GetCountryListResponse";
import FirmInformation from "./Components/FirmInformation";
import UnitAndRouteInformation from "./Components/UnitAndRouteInformation";
import DeliveryAndStatus from "./Components/DeliveryAndStatus";
import OrderDetails from "./Components/OrderDetails";
import ShippingAndDocumentInformation from "./Components/ShippingAndDocumentInformation";
import YurticiCargoExpectedIncomeOutcome from "./Components/YurticiCargoExpectedIncomeOutcome";
import FileArchives from "./Components/FileArchives";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import { ConstantService } from "../../../services/ConstantService";
import { poEslesmeDegistiBildir } from '../../../helpers/poGuncellemeDurumu';

const YurticiCargoAdd = () => {
    const navigate = useNavigate();
    const pageName = "Kargo Modülü > Yurtiçi Kargo > Siparişler"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth);

    const generalInformationRef: any = useRef();
    const firmInformationRef: any = useRef();
    const unitAndRouteInformationRef: any = useRef();
    const deliveryAndStatusRef: any = useRef();
    const productInformationRef: any = useRef();
    const shippingAndDocumentInformationRef: any = useRef();
    const expectedIncomeRef: any = useRef();
    const expectedOutcomeRef: any = useRef();
    const fileArchivesRef: any = useRef();

    const [trCountry, setTrCountry] = useState<GetCountryListResponseData | undefined>(undefined);
    const [trCurrency, setTrCurrency] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [yurticiCargoId, setYurticiCargoId] = useState<string | undefined>(undefined);

    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [selectedCustomer, setSelectedCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [shippingCode, setShippingCode] = useState<string | undefined>(undefined);
    const [integrationRefNo, setIntegrationRefNo] = useState<string | undefined>(undefined);
    const [selectedDivision, setSelectedDivision] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedPo, setSelectedPo] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [poNo, setPoNo] = useState<string | undefined>(undefined);

    const [senderCustomerCode, setSenderCustomerCode] = useState<string | undefined>(undefined);
    const [selectedSenderCustomer, setSelectedSenderCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [senderCustomerAddress, setSenderCustomerAddress] = useState<string | undefined>(undefined);
    const [selectedSenderCounty, setSelectedSenderCounty] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedSenderDistrict, setSelectedSenderDistrict] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [receiverCustomerCode, setReceiverCustomerCode] = useState<string | undefined>(undefined);
    const [selectedReceiverCustomer, setSelectedReceiverCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [receiverCustomerAddress, setReceiverCustomerAddress] = useState<string | undefined>(undefined);
    const [selectedReceiverCounty, setSelectedReceiverCounty] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedReceiverDistrict, setSelectedReceiverDistrict] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [selectedExitUnit, setSelectedExitUnit] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedArrivalUnit, setSelectedArrivalUnit] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDeliveryUnit, setSelectedDeliveryUnit] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [selectedShippingStatus, setSelectedShippingStatus] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [shippingCreateDate, setShippingCreateDate] = useState<string | undefined>(undefined);
    const [shippingLoadDate, setShippingLoadDate] = useState<string | undefined>(undefined);
    const [shippingDeliverDate, setShippingDeliverDate] = useState<string | undefined>(undefined);
    const [shippingDeliverer, setShippingDeliverer] = useState<string | undefined>(undefined);
    const [shippingReceiver, setShippingReceiver] = useState<string | undefined>(undefined);

    const [yurticiCargoProducts, setYurticiCargoProducts] = useState<GetYurticiCargoByIdResponseYurticiCargoProduct[]>([]);

    const [documentNo, setDocumentNo] = useState<string | undefined>(undefined);
    const [despatchNo, setDespatchNo] = useState<string | undefined>(undefined);
    const [consigmentNo, setConsigmentNo] = useState<string | undefined>(undefined);
    const [selectedDocumentType, setSelectedDocumentType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedReceivingType, setSelectedReceivingType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDeliveringType, setSelectedDeliveringType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedShippingRegion, setSelectedShippingRegion] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [expectedIncomes, setExpectedIncomes] = useState<GetYurticiCargoByIdResponseYurticiCargoExpectedIncomeOutcome[]>([]);
    const [expectedOutcomes, setExpectedOutcomes] = useState<GetYurticiCargoByIdResponseYurticiCargoExpectedIncomeOutcome[]>([]);

    const [fileArchives, setFileArchives] = useState<GetYurticiCargoByIdResponseFileArchive[]>([]);

    const [yurticiCargoMovements, setYurticiCargoMovements] = useState<GetYurticiCargoByIdResponseYurticiCargoMovement[]>([]);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            var response2: GetCountryListResponse = await CountryService.getCountryList('TR');

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            setTrCountry(response2.data.length > 0 ? response2.data[0] : undefined)

            var responseTrCurrency: GetConstantListResponse = await ConstantService.getConstantList('CURRENCY', undefined, 'TRY');

            if (!responseTrCurrency.isSuccess) {
                toast.error(responseTrCurrency.message)
                return;
            }

            setTrCurrency({ label: responseTrCurrency.data[0].value, value: responseTrCurrency.data[0].constantId, additionalValue1: responseTrCurrency.data[0].additionalValue1 });

            if (id) {
                var response: GetYurticiCargoByIdResponse = await YurticiCargoService.getYurticiCargoById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setYurticiCargoId(response.data.yurticiCargoId);
                setRefNo(response.data.refNo);

                if (response.data.customerId && response.data.customerName)
                    setSelectedCustomer({ label: response.data.customerName, value: response.data.customerId });

                setShippingCode(response.data.shippingCode);
                setIntegrationRefNo(response.data.integrationRefNo);

                if (response.data.divisionId && response.data.divisionName)
                    setSelectedDivision({ label: response.data.divisionName, value: response.data.divisionId });

                if (response.data.poId && response.data.poName)
                    setSelectedPo({ label: response.data.poName, value: response.data.poId });

                setPoNo(response.data.poNo);
                setIsPoManual(response.data.isPoManual);
                setPoManualInfo([response.data.poManualDateStr, response.data.poManualUserName].filter(x => x).join(' · ') || undefined);

                setSenderCustomerCode(response.data.senderCustomerCode);

                if (response.data.senderCustomerId && response.data.senderCustomerName)
                    setSelectedSenderCustomer({ label: response.data.senderCustomerName, value: response.data.senderCustomerId });

                if (response.data.senderCountyId && response.data.senderCountyName)
                    setSelectedSenderCounty({ label: response.data.senderCountyName, value: response.data.senderCountyId });

                setSenderCustomerAddress(response.data.senderCustomerAddress);

                if (response.data.senderDistrictId && response.data.senderDistrictName)
                    setSelectedSenderDistrict({ label: response.data.senderDistrictName, value: response.data.senderDistrictId });

                setReceiverCustomerCode(response.data.receiverCustomerCode);

                if (response.data.receiverCustomerId && response.data.receiverCustomerName)
                    setSelectedReceiverCustomer({ label: response.data.receiverCustomerName, value: response.data.receiverCustomerId });

                if (response.data.receiverCountyId && response.data.receiverCountyName)
                    setSelectedReceiverCounty({ label: response.data.receiverCountyName, value: response.data.receiverCountyId });

                setReceiverCustomerAddress(response.data.receiverCustomerAddress);

                if (response.data.receiverDistrictId && response.data.receiverDistrictName)
                    setSelectedReceiverDistrict({ label: response.data.receiverDistrictName, value: response.data.receiverDistrictId });

                if (response.data.exitUnitId && response.data.exitUnitName)
                    setSelectedExitUnit({ label: response.data.exitUnitName, value: response.data.exitUnitId });

                if (response.data.arrivalUnitId && response.data.arrivalUnitName)
                    setSelectedArrivalUnit({ label: response.data.arrivalUnitName, value: response.data.arrivalUnitId });

                if (response.data.deliveryUnitId && response.data.deliveryUnitName)
                    setSelectedDeliveryUnit({ label: response.data.deliveryUnitName, value: response.data.deliveryUnitId });

                if (response.data.shippingStatusId && response.data.shippingStatusName)
                    setSelectedShippingStatus({ label: response.data.shippingStatusName, value: response.data.shippingStatusId });

                setShippingCreateDate(response.data.shippingCreateDate);
                setShippingLoadDate(response.data.shippingLoadDate);
                setShippingDeliverDate(response.data.shippingDeliverDate);
                setShippingDeliverer(response.data.shippingDeliverer);
                setShippingReceiver(response.data.shippingReceiver);

                setYurticiCargoProducts(response.data.yurticiCargoProducts);

                setDocumentNo(response.data.documentNo);
                setDespatchNo(response.data.despatchNo);
                setConsigmentNo(response.data.consigmentNo);

                if (response.data.documentTypeId && response.data.documentTypeName)
                    setSelectedDocumentType({ label: response.data.documentTypeName, value: response.data.documentTypeId, additionalValue1: response.data.documentTypeKey });

                if (response.data.receivingTypeId && response.data.receivingTypeName)
                    setSelectedReceivingType({ label: response.data.receivingTypeName, value: response.data.receivingTypeId });

                if (response.data.deliveringTypeId && response.data.deliveringTypeName)
                    setSelectedDeliveringType({ label: response.data.deliveringTypeName, value: response.data.deliveringTypeId });

                if (response.data.shippingRegionId && response.data.shippingRegionName)
                    setSelectedShippingRegion({ label: response.data.shippingRegionName, value: response.data.shippingRegionId });

                setExpectedIncomes(response.data.yurticiCargoExpectedIncomeOutcomes.filter(x => x.isIncome));
                setExpectedOutcomes(response.data.yurticiCargoExpectedIncomeOutcomes.filter(x => !x.isIncome));

                setFileArchives(response.data.fileArchives);

                setYurticiCargoMovements(response.data.yurticiCargoMovements);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // "Yurtiçi Kargo Sipariş Güncelleme" rolü: Müşteri / Bölüm / PO / PO Numarası alanlarını değiştirebilir.
    // Kaydedince kayıt kilitlenir; entegrasyon senkronu ve toplu PO güncellemesi bu dört alana dokunmaz.
    const canUpdatePo = auth.user.user?.data.roles?.find(x => x == "Yurtiçi Kargo Sipariş Güncelleme") !== undefined;
    const [isPoManual, setIsPoManual] = useState(false);
    const [poManualInfo, setPoManualInfo] = useState<string | undefined>(undefined);

    const savePo = async () => {
        try {
            if (!yurticiCargoId) {
                toast.error("Önce kaydı açın.");
                return;
            }

            dispatch(storeActivityIndicator(true));

            var response: any = await YurticiCargoService.updateYurticiCargoPo(yurticiCargoId, selectedCustomer?.value, selectedDivision?.value, selectedPo?.value, poNo);

            if (!response.isSuccess) {
                toast.error(response.message);
                return;
            }

            setIsPoManual(true);
            setPoManualInfo([response.data?.poManualDateStr, response.data?.poManualUserName].filter((x: any) => x).join(' · ') || undefined);
            toast.success(response.message);
            poEslesmeDegistiBildir();
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const unlockPo = async () => {
        try {
            if (!yurticiCargoId)
                return;

            dispatch(storeActivityIndicator(true));

            var response: any = await YurticiCargoService.unlockYurticiCargoPo(yurticiCargoId);

            if (!response.isSuccess) {
                toast.error(response.message);
                return;
            }

            setIsPoManual(false);
            setPoManualInfo(undefined);
            toast.success(response.message);
            poEslesmeDegistiBildir();
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const saveYurticiCargo = async () => {
        try {
            dispatch(storeActivityIndicator(true));

            var obj: AddYurticiCargoRequest = {
                yurticiCargoId: yurticiCargoId,
                customerId: selectedCustomer?.value,
                refNo: refNo,
                divisionId: selectedDivision?.value,
                integrationRefNo: integrationRefNo,
                poId: selectedPo?.value,
                poNo: poNo,
                shippingCode: shippingCode,
                receiverCountyId: selectedReceiverCounty?.value,
                receiverCustomerAddress: receiverCustomerAddress,
                receiverCustomerCode: receiverCustomerCode,
                receiverCustomerId: selectedReceiverCustomer?.value,
                receiverDistrictId: selectedReceiverDistrict?.value,
                senderCountyId: selectedSenderCounty?.value,
                senderCustomerAddress: senderCustomerAddress,
                senderCustomerCode: senderCustomerCode,
                senderCustomerId: selectedSenderCustomer?.value,
                senderDistrictId: selectedSenderDistrict?.value,
                arrivalUnitId: selectedArrivalUnit?.value,
                deliveryUnitId: selectedDeliveryUnit?.value,
                exitUnitId: selectedExitUnit?.value,
                shippingCreateDate: shippingCreateDate,
                shippingDeliverDate: shippingDeliverDate,
                shippingDeliverer: shippingDeliverer,
                shippingLoadDate: shippingLoadDate,
                shippingReceiver: shippingReceiver,
                shippingStatusId: selectedShippingStatus?.value,
                yurticiCargoProducts: yurticiCargoProducts.map(function (x) {
                    return {
                        yurticiCargoProductId: x.yurticiCargoProductId.startsWith('newrecrd') ? undefined : x.yurticiCargoProductId,
                        desi: x.desi?.toString(),
                        detailVolumetricWeight: x.detailVolumetricWeight?.toString(),
                        potTypeId: x.potTypeId,
                        product: x.product,
                        quantity: x.quantity?.toString(),
                        weight: x.weight?.toString()
                    }
                }),
                deliveringTypeId: selectedDeliveringType?.value,
                documentNo: documentNo,
                despatchNo: despatchNo,
                consigmentNo: consigmentNo,
                documentTypeId: selectedDocumentType?.value,
                receivingTypeId: selectedReceivingType?.value,
                shippingRegionId: selectedShippingRegion?.value,
                yurticiCargoExpectedIncomeOutcomes: [...expectedIncomes, ...expectedOutcomes].map(function (x) {
                    return {
                        yurticiCargoExpectedIncomeOutcomeId: x.yurticiCargoExpectedIncomeOutcomeId.startsWith('newrecrd') ? undefined : x.yurticiCargoExpectedIncomeOutcomeId,
                        currency: x.currency,
                        currencyTypeId: x.currencyTypeId,
                        description: x.description,
                        invoiceDate: x.invoiceDate,
                        invoiceNo: x.invoiceNo,
                        isApproved: x.isApproved ? 1 : 0,
                        isIncome: x.isIncome ? 1 : 0,
                        quantity: x.quantity?.toString(),
                        serviceId: x.serviceId,
                        taxPrice: x.taxPrice?.toString(),
                        totalPrice: x.totalPrice?.toString(),
                        totalWithoutTaxPrice: x.totalWithoutTaxPrice?.toString(),
                        unitPrice: x.unitPrice?.toString(),
                        taxRate: x.taxRate
                    }
                }),
                fileArchives: fileArchives.map(function (x) {
                    return {
                        description: x.description,
                        entityId: x.entityId,
                        file: x.fileArchiveFile,
                        fileName: x.fileName,
                        fileTypeId: x.fileTypeId,
                        fileArchiveId: x.fileArchiveId
                    }
                }),
            };

            var response: AddYurticiCargoResponse = await YurticiCargoService.addYurticiCargo(obj);

            if (!response.isSuccess) {
                toast.error(response.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(response.message)

            dispatch(storeActivityIndicator(false));
            navigate(Helpers.getGoBackUrl())
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bil.', ref: generalInformationRef },
                            { text: 'Firma Bil.', ref: firmInformationRef },
                            { text: 'Birim ve Rota Bil.', ref: unitAndRouteInformationRef },
                            { text: 'Gönderi ve Evrak Bil.', ref: shippingAndDocumentInformationRef },
                            { text: 'Sip. Detayları', ref: productInformationRef },
                            { text: 'Teslimat ve Durum', ref: deliveryAndStatusRef },
                            { text: 'Bek. Gelir', ref: expectedIncomeRef },
                            { text: 'Bek. Gider', ref: expectedOutcomeRef },
                            { text: 'Dijital Arşiv', ref: fileArchivesRef },
                        ]}
                    />

                    <GeneralInformation
                        generalInformationRef={generalInformationRef}
                        integrationRefNo={integrationRefNo}
                        poNo={poNo}
                        refNo={refNo}
                        selectedCustomer={selectedCustomer}
                        selectedDivision={selectedDivision}
                        selectedPo={selectedPo}
                        setIntegrationRefNo={setIntegrationRefNo}
                        setPoNo={setPoNo}
                        setRefNo={setRefNo}
                        setSelectedCustomer={setSelectedCustomer}
                        setSelectedDivision={setSelectedDivision}
                        setSelectedPo={setSelectedPo}
                        setShippingCode={setShippingCode}
                        shippingCode={shippingCode}
                        canUpdatePo={canUpdatePo}
                        shippingCreateDate={shippingCreateDate}
                        isPoManual={isPoManual}
                        poManualInfo={poManualInfo}
                        savePo={savePo}
                        unlockPo={unlockPo}
                    />

                    <FirmInformation
                        firmInformationRef={firmInformationRef}
                        receiverCustomerAddress={receiverCustomerAddress}
                        receiverCustomerCode={receiverCustomerCode}
                        selectedReceiverCounty={selectedReceiverCounty}
                        selectedReceiverCustomer={selectedReceiverCustomer}
                        selectedReceiverDistrict={selectedReceiverDistrict}
                        selectedSenderCounty={selectedSenderCounty}
                        selectedSenderCustomer={selectedSenderCustomer}
                        selectedSenderDistrict={selectedSenderDistrict}
                        senderCustomerAddress={senderCustomerAddress}
                        senderCustomerCode={senderCustomerCode}
                        setReceiverCustomerAddress={setReceiverCustomerAddress}
                        setReceiverCustomerCode={setReceiverCustomerCode}
                        setSelectedReceiverCounty={setSelectedReceiverCounty}
                        setSelectedReceiverCustomer={setSelectedReceiverCustomer}
                        setSelectedReceiverDistrict={setSelectedReceiverDistrict}
                        setSelectedSenderCounty={setSelectedSenderCounty}
                        setSelectedSenderCustomer={setSelectedSenderCustomer}
                        setSelectedSenderDistrict={setSelectedSenderDistrict}
                        setSenderCustomerAddress={setSenderCustomerAddress}
                        setSenderCustomerCode={setSenderCustomerCode}
                        trCountry={trCountry}
                    />

                    <UnitAndRouteInformation
                        unitAndRouteInformationRef={unitAndRouteInformationRef}
                        selectedArrivalUnit={selectedArrivalUnit}
                        selectedDeliveryUnit={selectedDeliveryUnit}
                        selectedExitUnit={selectedExitUnit}
                        setSelectedArrivalUnit={setSelectedArrivalUnit}
                        setSelectedDeliveryUnit={setSelectedDeliveryUnit}
                        setSelectedExitUnit={setSelectedExitUnit}
                    />

                    <ShippingAndDocumentInformation
                        shippingAndDocumentInformationRef={shippingAndDocumentInformationRef}
                        documentNo={documentNo}
                        selectedDeliveringType={selectedDeliveringType}
                        selectedDocumentType={selectedDocumentType}
                        selectedReceivingType={selectedReceivingType}
                        selectedShippingRegion={selectedShippingRegion}
                        setDocumentNo={setDocumentNo}
                        setSelectedDeliveringType={setSelectedDeliveringType}
                        setSelectedDocumentType={setSelectedDocumentType}
                        setSelectedReceivingType={setSelectedReceivingType}
                        setSelectedShippingRegion={setSelectedShippingRegion}
                        despatchNo={despatchNo}
                        setDespatchNo={setDespatchNo}
                        consigmentNo={consigmentNo}
                        setConsigmentNo={setConsigmentNo}
                    />

                    <OrderDetails
                        productInformationRef={productInformationRef}
                        setYurticiCargoProducts={setYurticiCargoProducts}
                        yurticiCargoProducts={yurticiCargoProducts}
                    />

                    <DeliveryAndStatus
                        deliveryAndStatusRef={deliveryAndStatusRef}
                        selectedShippingStatus={selectedShippingStatus}
                        setSelectedShippingStatus={setSelectedShippingStatus}
                        setShippingCreateDate={setShippingCreateDate}
                        setShippingDeliverDate={setShippingDeliverDate}
                        setShippingDeliverer={setShippingDeliverer}
                        setShippingLoadDate={setShippingLoadDate}
                        setShippingReceiver={setShippingReceiver}
                        shippingCreateDate={shippingCreateDate}
                        shippingDeliverDate={shippingDeliverDate}
                        shippingDeliverer={shippingDeliverer}
                        shippingLoadDate={shippingLoadDate}
                        shippingReceiver={shippingReceiver}
                        yurticiCargoMovements={yurticiCargoMovements}
                    />

                    {
                        trCurrency && (
                            <React.Fragment>
                                <YurticiCargoExpectedIncomeOutcome
                                    expectedIncomeRef={expectedIncomeRef}
                                    expectedIncomes={expectedIncomes}
                                    isIncome={true}
                                    setExpectedIncomes={setExpectedIncomes}
                                    trCurrency={trCurrency}
                                />

                                <YurticiCargoExpectedIncomeOutcome
                                    expectedIncomeRef={expectedOutcomeRef}
                                    expectedIncomes={expectedOutcomes}
                                    isIncome={false}
                                    setExpectedIncomes={setExpectedOutcomes}
                                    trCurrency={trCurrency}
                                />
                            </React.Fragment>
                        )
                    }

                    <FileArchives
                        fileArchives={fileArchives}
                        fileArchivesRef={fileArchivesRef}
                        setFileArchives={setFileArchives}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveYurticiCargo}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default YurticiCargoAdd;